import React, { useState } from "react";
import { locales } from "../../locales";
import CandidatesElected from "../Canditates/CandidatesElected";
import { formatDate } from "../../utils/communesUtils";

const Elected = ({
  data,
  langId,
  isDesktop,
  currentElected,
  meta,
  handleShowTooltip,
  handleHideTooltip,
  communeId,
  isSpeacialCase,
}) => {
  const [selectedYear, setSelectedYear] = useState(2023);
  const isBigCommune = data["2023"].results.resultats?.listes?.length > 1;
  const candidatesLookup = meta?.[0]?.parties.filter(
    (item) => item.candidates.length > 0
  );

  const getElectedCandidates = (isBigCommune, year) => {
    if (isBigCommune) {
      if (data[year].results.resultats.candidats) {
        return data[year].results.resultats.candidats
          .filter((item) => item.elu === "ELU")
          .sort((a, b) => parseInt(b.suffrages) - parseInt(a.suffrages));
      } else {
        return data[year].results.resultats.listes
          .flatMap((item) => {
            let sigle = item.sigles[0].sigle.contenu;
            return item.candidats
              .filter((candidate) => candidate.elu === "ELU")
              .map((candidate) => ({ ...candidate, sigle: sigle }));
          })
          .sort((a, b) => parseInt(b.suffrages) - parseInt(a.suffrages));
      }
    } else {
      if (
        data[year] &&
        data[year].results &&
        data[year].results.resultats &&
        data[year].results.resultats.candidats
      ) {
        return data[year].results.resultats.candidats
          .filter((item) => item.elu === "ELU")
          .sort((a, b) => parseInt(b.suffrages) - parseInt(a.suffrages));
      } else {
        // Handle the case where the data structure doesn't match what you're expecting.
        console.error("Unexpected data structure");
      }
    }
  };

  const electedCandidates2017 = getElectedCandidates(isBigCommune, 2017);
  const electedCandidates2023 = getElectedCandidates(isBigCommune, 2023);

  const electedData =
    selectedYear === 2023 ? electedCandidates2023 : electedCandidates2017;

  const getButtonClasses = (year) => {
    let baseClasses =
      "relative inline-flex items-center justify-center px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-10 w-184 h-40";

    if (year === selectedYear) {
      baseClasses +=
        " bg-blueTranslucent text-blueFocus border-2 border-blueFocus";
    } else {
      baseClasses += " bg-white text-blueFocus border-2 border-blueFocus";
    }

    if (year === 2017) {
      baseClasses += " -ml-px rounded-r-md";
    } else {
      baseClasses += " rounded-l-md";
    }

    return baseClasses;
  };

  return (
    <div className="flex flex-col mt-20">
      <div className="flex flex-row border-2 border-gray-200 border-t-0 border-l-0 border-r-0 pb-2">
        <span className="font-semibold text-32 leading-38 uppercase w-2/4">
          {locales[langId].electedCandidates}
        </span>
        <div className="pt-3 text-right w-2/4">
          {isDesktop && (
            <span
              className="mr-10 text-xs"
              style={{ color: "rgba(0, 0, 0, 0.6)" }}
            >
              {locales[langId].resultsUpdated +
                " " +
                formatDate(data["2023"].results.dateDerniereModification) +
                " " +
                locales[langId].resultsHour}
            </span>
          )}
        </div>
      </div>
      <hr />
      <div className="flex flex-col mt-6">
        <span className="isolate inline-flex rounded-md">
          <button
            type="button"
            className={getButtonClasses(2023)}
            onClick={() => setSelectedYear(2023)}
          >
            2023
          </button>

          {!isSpeacialCase && (
            <button
              type="button"
              className={getButtonClasses(2017)}
              onClick={() => setSelectedYear(2017)}
            >
              2017
            </button>
          )}
        </span>
      </div>
      <div className="flex flex-col mt-6">
        <CandidatesElected
          data={electedData}
          langId={langId}
          isDesktop={isDesktop}
          isBigCommune={isBigCommune}
          currentElected={currentElected}
          year={selectedYear}
          candidatesLookup={candidatesLookup}
          onShowTooltip={handleShowTooltip}
          onHideTooltip={handleHideTooltip}
          communeId={communeId}
        />
      </div>
    </div>
  );
};

export default Elected;
